/* global globalThis */
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ROUTE_CONST } from "../../Constants/route.constant";
import userIcon from "../../assets/images/userIcon.svg";
import logoutImg from "../../assets/images/signout-icon.svg";
import emailIMG from "../../assets/images/mail-icon.svg";
import "./styles.scss";
import { localStorageGetItem } from "../../../src/utils/Storage/storageUtils";
import { removeStorage, noop, handleKeyboardEvent } from "../../utils/Helper";
import { APP_CONST } from "../../Constants/app.constant";
import { logoutKeycloak } from "../../auth/Keycloak";

const UserAccount = () => {
  const navigate = useNavigate();
  const userid = localStorageGetItem(APP_CONST.KEYCLOAK_STORAGE_KEYS.EMAIL_ID);
  const [isHovered, setIsHovered] = useState(false);

  const handleLogout = () => {
    removeStorage();
    if (globalThis?.IS_SSO_ENABLED === "TRUE") {
      logoutKeycloak();
    } else {
      navigate(ROUTE_CONST.LOGIN);
    }
  };

  const userMenu = [
    {
      icon: emailIMG,
      label: userid,
      onClickHandler: noop,
    },
    {
      icon: logoutImg,
      label: APP_CONST.SIGN_OUT,
      onClickHandler: handleLogout,
    },
  ];

  return (
    <nav
      className="user-account-wrapper h-100 d-flex align-items-center px-2"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <button
        type="button"
        className="profile-icon h-100 d-flex align-items-center"
        onFocus={() => setIsHovered(true)}
        onBlur={() => setIsHovered(false)}
        aria-haspopup="true"
        aria-expanded={isHovered}
        tabIndex={0}
      >
        <img alt="user" src={userIcon} className="user-icon" />
      </button>

      {isHovered && (
        <div className="d-flex flex-column gap-3 p-3 user-menu-item">
          {userMenu.map((item) => (
            <button
              type="button"
              key={`menuItem-${item.label ?? item.icon}`}
              className="d-flex gap-2 align-items-center menuItem menuItem-btn"
              onClick={() => item.onClickHandler()}
              onKeyDown={(e) => handleKeyboardEvent(e, item.onClickHandler)}
              tabIndex={0}
            >
              <span className="img-box">
                <img alt="email" src={item.icon} width="20" height="20" />
              </span>
              <span className="menu-item">{item.label}</span>
            </button>
          ))}
        </div>
      )}
    </nav>
  );
};

export default UserAccount;
